<template>
	<div class="content-detail">
		<v v-if="isVerticalScreen()" />
		<h v-else />
	</div>
</template>
<script>
	import {
		mapGetters
	} from 'vuex'
	import H from './H.vue';
	import V from './V.vue';
	export default {
		name: 'ContentDetail',
		components: {
			H,
			V
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			...mapGetters(["isVerticalScreen"]),
		}
	}
</script>
<style scoped lang="less">
	.content-detail {
		width: 100%;
		height: 100%;
	}
</style>